const DeviceMonitor = () => import('Views/device/device-monitor');
const MonitorPage = () => import('Views/monitorDevice/monitor-page');

export default[
  { path: '/device-monitor', component: DeviceMonitor },
  { path: '/monitor-page', component: MonitorPage },
];



// WEBPACK FOOTER //
// ./src/router/deviceMonitor.js